import { render, staticRenderFns } from "./OfferBanner.vue?vue&type=template&id=4fd0f904"
import script from "./OfferBanner.vue?vue&type=script&lang=js"
export * from "./OfferBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports